import styled, {css} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';

import FontAwesome from 'react-native-vector-icons/FontAwesome';
import FastImage from 'react-native-fast-image';

interface Check {
  checked?: boolean;
}

export const Container = styled.View`
  flex: 1;
  background: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const SectionScroll = styled.ScrollView`
  margin: 0 -24px;
  margin-top: ${RFValue(12)}px;
  flex: 1;
`;

export const Section = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  padding: 0 24px;
  margin-bottom:${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Item = styled.TouchableOpacity<Check>`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(8)}px 24px;
  border-style: solid;
  border-bottom-width: 1px;
  border-color: ${({theme}) => theme.colors.border};

  ${({theme, checked}) => checked && css`
    background-color:rgba(16, 174, 202, 0.1);
  `}
`;

export const LeftContent = styled.View`
  flex-direction: row;
  align-items: flex-start;
`;

export const Infos = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const Icon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(16)}px;
  margin-top: 4px;
  color: ${({theme}) => theme.colors.text};
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const Title = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;

export const Description = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  text-transform: capitalize;
`;

export const Value = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
`;

export const TotalDebits = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const TotalDebitsTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
`;
export const TotalDebitsValue = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
`;
export const LinkButton = styled.TouchableOpacity`
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
`;
export const LinkButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
`;

export const DetailsButton = styled.TouchableOpacity`
  flex:1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(6)}px 0;
  margin-top: ${RFValue(6)}px;
  border-top-width: 1px;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
`;
export const DetailsButtonText = styled.Text`
 font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  background-color: ${({})};
`;
export const DetailsButtonIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.text};
`;

export const Payment = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BrandContainer = styled.View`
    width: ${RFValue(20)}px;
    height: ${RFValue(13)}px;
  align-items: center;
  
  justify-content: center;
`;

//@ts-ignore
export const BrandImage = styled(FastImage)`
  width: ${RFValue(20)}px;
  height: ${RFValue(13)}px;
`;

export const PaymentMethodInfo = styled.View`
  flex-direction: column;
  align-items: flex-start;
  padding:${RFValue(6)}px 0;
  justify-content: flex-start;
`;
export const PaymentTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(10)}px;
  margin-left: ${RFValue(6)}px;
`;
